import { createFileRoute } from "@tanstack/react-router";
import { options } from "@/pages/why-is-my-gif-so-big";

export const Route = createFileRoute("/blog/why-is-my-gif-so-big")(options);
